<template>
  <div class="vc-support-ticket-portal">
    <div v-if="hasSession" class="d-flex justify-content-between align-items-center mb-3">
      <h4 class="mb-0">{{ $t('messages.myTickets') }}</h4>
      <button v-if="view !== 'create'" type="button" class="btn btn-primary btn-sm" @click="showCreate">
        <i class="bi bi-plus-lg me-1"></i>{{ $t('messages.newTicket') }}
      </button>
      <button v-else type="button" class="btn btn-outline-secondary btn-sm" @click="showList">
        <i class="bi bi-arrow-left me-1"></i>{{ $t('messages.backToList') }}
      </button>
    </div>

    <SupportTicketForm v-if="view === 'create'" :recaptcha-site-key="recaptchaSiteKey"
      :ai-followup-context="aiFollowupContext" @view-ticket="openTicket" @back-to-list="showList" />
    <TicketList v-else-if="view === 'list'" @open-ticket="openTicket" @new-ticket="showCreate" />
    <TicketThread v-else-if="view === 'thread'" :ticket-id="activeTicketId" @back="showList" />
  </div>
</template>

<script>
import SupportTicketForm from './SupportTicketForm.vue';
import TicketList from './TicketList.vue';
import TicketThread from './TicketThread.vue';
import translations from '@/translations/supportticket.js';

/**
 * Single mount point composing create (§12.2/§12.3), list (§8.1) and thread+reply (§8.2/§8.3) into
 * one portal, since this project mounts one component per page div rather than using a router.
 * Signed-in users land on their ticket list (the more common need for a returning user); anonymous
 * visitors land on the create form, since they have no ticket list to show. A successful submission
 * routes forward into the ticket/list rather than nudging the user to submit another one.
 */
export default {
  name: 'SupportTicketPortal',
  i18n: {
    messages: {
      en: translations.en,
      de: translations.de,
    },
  },
  props: {
    recaptchaSiteKey: {
      type: String,
      default: null,
    },
    aiFollowupContext: {
    type: Object,
    default: null,
    },
  },
  data() {
    return {
      sessionId: null,
      view: 'create',
      activeTicketId: null,
      hasUrlTicketRequest: !!(new URLSearchParams(window.location.search).get('type') || '').trim(),
    };
  },
  computed: {
    hasSession() {
      return !!this.sessionId;
    },
  },
  methods: {
    showCreate() {
      this.view = 'create';
    },
    showList() {
      this.view = 'list';
      this.activeTicketId = null;
    },
    openTicket(ticketId) {
      this.activeTicketId = ticketId;
      this.view = 'thread';
    },
  },
  mounted() {
    var me = this;
    var vcCommunicator = window.vcCommunicator;
    if (!vcCommunicator) {
      console.log('No vcCommunicator');
      return;
    }
    me.sessionId = vcCommunicator.sessionId;
    me.view = me.sessionId && !me.hasUrlTicketRequest ? 'list' : 'create';

    vcCommunicator.addHandler('createsession', function (sessionId) {
      me.sessionId = sessionId;
      // vcCommunicator fires 'createsession' with a null sessionId when anonymous init completes
      // (the 'createsessionfailed' dispatch is commented out there) - only a real session may
      // switch the view to the ticket list, otherwise anonymous visitors land on the list's
      // sign-in banner instead of the create form.
      if (sessionId && me.view === 'create' && !me.activeTicketId && !me.hasUrlTicketRequest) {
        me.view = 'list';
      }
    });
    vcCommunicator.addHandler('terminatesession', function () {
      me.sessionId = null;
      me.view = 'create';
      me.activeTicketId = null;
    });
  },
  components: {
    SupportTicketForm,
    TicketList,
    TicketThread,
  },
};
</script>
